document.addEventListener('DOMContentLoaded', function() {
  const tabContainers = document.querySelectorAll('.tabs');
  
  tabContainers.forEach(container => {
    const tabItems = container.querySelectorAll('.tabs__items__content > .tabs__item');
    const tabTitles = container.querySelectorAll('.tabs__items__heading > p');
    
    if (tabItems.length > 0 && tabTitles.length > 0) {
      tabItems[0].setAttribute('active', '');
      tabTitles[0].setAttribute('active', '');
    }
    
    tabTitles.forEach((title, index) => {
      title.addEventListener('click', function() {
        const contentTab = tabItems[index];
        
        if (!contentTab) return;
        
        if (contentTab.hasAttribute('active')) {
          return;
        }
        
        tabItems.forEach(item => item.removeAttribute('active'));
        tabTitles.forEach(title => title.removeAttribute('active'));
        
        contentTab.setAttribute('active', '');
        title.setAttribute('active', '');
      });
    });
  });
});